import { render, staticRenderFns } from "./account.delete-success.vue?vue&type=template&id=ed0c2576&"
import script from "./account.delete-success.vue?vue&type=script&lang=js&"
export * from "./account.delete-success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports